import type { i18n as i18nInstance } from "i18next";

import { useLayoutEffect } from "react";
import enUS from "./en-US";
import frFR from "./fr-FR";

interface Props {
  children: React.ReactNode;
  i18n: i18nInstance;
}

const ProductTranslationProvider = ({ children, i18n }: Props) => {
  useLayoutEffect(() => {
    if (!i18n.hasResourceBundle("en-US", "products")) {
      i18n.addResourceBundle("en-US", "products", enUS);
    }
    if (!i18n.hasResourceBundle("fr-FR", "products")) {
      i18n.addResourceBundle("fr-FR", "products", frFR);
    }
  }, [i18n]);

  return children;
};

export default ProductTranslationProvider;
